import { Draft, PayloadAction }      from '@reduxjs/toolkit';
import { IOrganisationInvoiceState } from 'Redux/Slices/OrganisationInvoice/OrganisationInvoiceSlice';
import { OrganisationInvoice }       from 'Domain/Models';
import { removeActionTypes }         from 'Utils/ReducerUtility';

export const findOrganisationInvoiceRequest = (state: Draft<IOrganisationInvoiceState>, { type }: PayloadAction<{ id: string }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const findOrganisationInvoiceSuccess = (state: Draft<IOrganisationInvoiceState>, { type, payload }: PayloadAction<{
  organisationInvoice: OrganisationInvoice
}>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.entries = { ...state.entries, [payload.organisationInvoice.id]: payload.organisationInvoice };
};

export const findOrganisationInvoiceFailure = (state: Draft<IOrganisationInvoiceState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
